import Component from './Login'

export default Component
